import { Container, Heading1, ImageLite } from "shared/components";

import styles from "./Hero048.module.scss";

export const Hero048 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const logos = payload?.logos ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blocks}>
          <Heading1 className={styles.headline}>{headline}</Heading1>
          <div className={styles.logos}>
            {logos.map((item) => (
              <ImageLite
                key={item.id}
                image={item.image}
                className={styles.logo}
              />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero048;
